module.exports = __webpack_public_path__ + "static/media/TvShowBanner (14).7c2481d8.png";